module.exports = __webpack_public_path__ + "img/Icon-sidebar-Profile.54d4abc6.svg";